import React, {useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Button, Form, Nav, Navbar, Alert, Badge, FloatingLabel, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../context/AuthProvider';
import axios from 'axios';
import UserSurvey from './usersurvey.component';
import { prefixes, canadianUniversitiesByProvince, canadianUniversities, selectOptions, compareEventDate } from '../../../tools/main';
import { Slack } from 'react-bootstrap-icons';

const slack_link_never_expires = "https://join.slack.com/t/csam-scma/shared_invite/zt-2rog5i1pf-DVbTTGKdYG~AyJz2DQX8ng"

const msg_membership_expired = (membershipexpirationdate) => {
    return (
        <div>
            <p> Dear Member, </p>
            <p>
                We would like to inform you that your membership had expired on <strong> {unixToDate(membershipexpirationdate) } </strong>. 
                You can renew your membership here: <a href='/signup-membership'> Membership renewal </a>
            </p>
        </div>
    )
}                        

function msg_upcoming_membership_exp (membershipactivationdate){

    return (
        <div>
            <p> Dear member, </p>
            <p>
                Your membership is set to expire on {membershipactivationdate}. 
                To continue enjoying your benefits without interruption, 
                please renew your membership here: <a href='/signup-membership'>Renew Your Membership</a>.         
            </p>
        </div>
    )
}
function unixToDate(timeStamp) {
    if (timeStamp != false) {
        // console.log("timeStamp:", timeStamp)
        const date = new Date(timeStamp)
        // console.log(date)
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const dateString = date.toLocaleString('en-US', options);
        
        return dateString; 
    } else {
        return "Not a Member"
    }

}

function displayPlainTxt (variableTitle, variableValue) {

    return (
        <Form.Group as={Row} className="mb-1" controlId="formPlaintextEmail">
        <Form.Label column xs="6" sm="4" style={{ }}>
          { variableTitle }
        </Form.Label>
        <Col xs="6" sm="8" >
          <Form.Control style={{ textAlign: 'center'}} plaintext readOnly defaultValue= { variableValue } />
        </Col>
      </Form.Group>
    )
}


function MembersDashboard () {

    return (
        <>  
            
            <Card.Body >
                <h5> Member's Dashboard </h5>

    
                <ul style={{ padding: "16px"}}>
                    <li> <a href= { slack_link_never_expires}> Member's Slack Workspace </a> <Slack /> </li>
                    <li>  <a href="https://www.royalcollege.ca/en/credentials-exams/exam-eligibility/areas-focussed-competence-afc-diploma/apply-afc-practicing.html"> Practice Eligibility Route - AFC </a> </li>
                </ul>
            </Card.Body>
        </>
    )
} 


function UpdateProfile({}) {
    const navigate = useNavigate()
    const [successMessage, setSuccessMessage] = useState('')
    const [errMessage, setErrMessage] = useState('')
    const {auth, setAuth} = useContext(AuthContext)


    const [lastName, setLastName] = useState(auth?.lastname)
    const [firstName, setFirstName] = useState(auth?.firstname)
    const [prefix, setPrefix] = useState(auth?.prefix)    
    const [country, setCountry] = useState(auth.address?.country)
    const [city, setCity] = useState(auth.address?.city)
    const [province, setProvince] = useState(auth.address?.province)
    const [street1, setStreet1] = useState(auth.address?.street1)
    const [street2, setStreet2] = useState(auth.address?.street2)
    const [postalCode, setPostalCode] = useState(auth.address?.postalCode)


    // const [address, setAddress] = useState(auth.address == null? ({
    //     country: '',
    //     city: '',
    //     province: '',
    //     street1: '',
    //     street2:'',
    //     postalCode: ''
    //   }):(auth.address));


    const handleUpdateProfile = async (e) => {
        e.preventDefault()

        const filter = { email: auth.email }
        const newAdress = { street1, street2, city, province, country, postalCode }
        const form_data = { prefix, firstName, lastName,
            displayName: firstName + ' ' + lastName,
            address: newAdress
        }

        console.log(form_data)
        axios.post('/user/update-profile', { filter, form_data}).then(res => {
            if (res.data.success) {
                //set success message

                setSuccessMessage("Done! your profile was successfully updated")

                //update auth
                let updateAuth = {...res.data.user} //create a copy

                updateAuth.loggedIn = true
                updateAuth.accessToken = res.data.accessToken

                setAuth(updateAuth)

                //update token
                localStorage.setItem("accessToken", res.data.accessToken)
            } else {
                //set error message that updates could not be down
                setErrMessage("We could not update your profile. Please try again at a later time.")
            }
        }).catch(err=> {
            // set error that backend could not update data
            setErrMessage("We could not update your profile. Please try again at a later time.")
        }) }
    return (
        <>

                <Card.Body>
                    {
                        successMessage != '' ? (<Alert variant="success"> {successMessage} </Alert>):(<></>)
                    }
                        <Form>
                            <Form.Label> <h5> Update profile </h5></Form.Label>   
                            <Form.Group className='mt-1'>
                                <FloatingLabel label="Prefix">
                                    <Form.Select onChange= {e => setPrefix(e.target.value)} >
                                        <option value={ auth.prefix } > { auth.prefix }</option>
                                        {
                                            prefixes.map(name => {
                                                if (name != auth.prefix) {
                                                    return <option value={ name } > {  name }</option>
                                                }
                                                
                                            })             
                                        }
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                            <Form.Group  className='form-group mt-3' >
                                                                
                                <Row>
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={firstName}
                                            onChange={e=>setFirstName(e.target.value)}
                                            placeholder='First Name'
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={lastName}
                                            onChange={e=>setLastName(e.target.value)}
                                            placeholder='Last Name'
                                            />
                                    </Col>
                                </Row>

                            </Form.Group>

                            
                            <Form.Group className='form-group mt-3 mb-3' >
                                <Form.Label>Address</Form.Label>

                                <Row className="mt-1">
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={street1} 
                                            onChange={e=> {setStreet1(e.target.value) }} 
                                            placeholder='Address Line 1'/>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={street2} 
                                            placeholder='Address Line 2 (e.g., Apartment unit, suite, floor, building,department numbers, or PO Boxes.)'
                                            onChange={e=> {setStreet2(e.target.value) }} 
                                            />
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={city} 
                                            onChange={e=> {setCity(e.target.value) }} 
                                            placeholder='City'/>
                                        </Col>
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={province}
                                            onChange={e=> {setProvince(e.target.value) }}  
                                            placeholder='Province/State'/>
                                    </Col>

                                </Row>
                                <Row className="mt-2">
                                    <Col>
                                        <Form.Control 
                                        type="text" v
                                        value={country} 
                                        onChange={e=> {setCountry(e.target.value) }} 
                                        placeholder='Country' />
                                    </Col>
                                    <Col>
                                        <Form.Control 
                                            type="text" 
                                            value={postalCode} 
                                            onChange={e=> {setPostalCode(e.target.value) }} 
                                            placeholder='Postal/Zip code'/>
                                    </Col>
                                </Row>
            
                            
                            </Form.Group>
                            <Form.Group className="mt-2" style={{ textAlign: "center"}}>
                                <Button  
                                    variant="warning" 
                                    onClick={ e=> handleUpdateProfile(e)} 
                                    id="update-profile-btn" 
                                    className="round-btn" > Update </Button>
                            </Form.Group>
                    </Form>
                    
                </Card.Body>
        </>
    )
}

function MyAccount () {
    const navigate = useNavigate()
    const {auth, setAuth} = useContext(AuthContext)
    const [mounted, didMount] = useState(false)
    const [loading, isLoading]= useState(true)
    

    useEffect(()=> {
        didMount(true)
    }, [])
    useEffect(()=> {
        if (mounted) isLoading(false)
    }, [mounted])

    if (!loading) return (
        <>
        
        <Card.Header> <h4> My Account </h4> </Card.Header>
        <Card.Body className="myaccount" >
            <Alert variant='danger' className= { auth.membershipstatus != 'Pending'? ("hide"):("show")}>
                { msg_membership_expired(auth.membershipexpirationdate) }
            </Alert>

            <h5 className='mt-3 mb-3'> Account </h5>
            { displayPlainTxt("Name", auth.displayname )}
            { displayPlainTxt("CSAM ID", auth.userid)}
            { displayPlainTxt("Email", auth.email )}
            <br />
            <hr />
            <h5 className='mt-3 mb-3'> Membership  </h5>
            { displayPlainTxt("Membership Status", auth.membershipstatus == 'Inactive' ? 'Not a Member': auth.membershipstatus )}
            
            { auth.membershipstatus !== 'Inactive' && (
                <>
                    { displayPlainTxt("Membership Type", auth.membershiptype == 'null' ? 'Not a Member': auth.membershiptype )}
                    { displayPlainTxt("Activation Date", unixToDate(auth.membershipactivationdate) )}
                    { displayPlainTxt("Expiration Date", unixToDate(auth.membershipexpirationdate) )}
                </>
            )}

                <div >


                    <Alert variant='warning'  className= { auth.membershipstatus == 'Active' && parseInt(auth.membership_days_to_exp) <= 30? ("show"):("hide")}>
                        { msg_upcoming_membership_exp(auth.membershipexpirationdate)}
                    </Alert>

                    <Button className= { auth.membershipstatus != 'Active' ? ("hide"):("show")} onClick={e=> { window.open(slack_link_never_expires , '_blank') }}> Slack Membeship Access </Button>
                </div>
            <div className="mt-3" style={{ textAlign: "center"}}>
                <Button  variant="warning" className={ auth.membershipstatus == "Active" ? "hide": "show btn-become-member"}onClick={ (e) => { navigate("/signup-membership")}}> 
                    Get Membership Access 
                </Button>
            </div>
            </Card.Body>
        </>
    )
}

function UserBoard ({auth, currUserView}) {
    const navigate = useNavigate()

    return (
        <Row id="userboard">
            <Card className='userboard-card'>
                <div className={currUserView == '' ? "show":"hide"}> 
                    < MyAccount />
                </div>

                <div className={currUserView == 'update-profile' ? "show":"hide"}>
                    <UpdateProfile />
                </div>
                
                <div className= {auth.ismember == 'true' ? ('show'):('hide')}>
                    <div className={currUserView == 'members-view' ? "show":"hide"}>
                        <MembersDashboard />
                    </div>
                </div>

                    
            </Card>
        </Row>
    )
}
 export default function UserAccount() {
    const {auth, setAuth} = useContext(AuthContext)
    const navigate = useNavigate()
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [currUserView, setUserView] = useState('')


    useEffect(()=> {
        // console.log(auth)

    },[auth])

    useEffect(()=> {
        didMount(true)
    }, [])

    useEffect(()=> {
        if (isMounted) {
            isLoading(false)
        }
    },[auth, isMounted])



    if (!loading) return(
        <Container>
           <Row className='mt-100 p-2' >
                <Col className="mx-auto mw-900 ">
                    <Row style={{ height: ""}}>
                        <Col sm={8} md={4} className="mx-auto mb-2" style={{ padding: "2px"}}>
                            <Card  className="" >
                                <Card.Body style={{ padding: "2px"}}>
                                    {/* <Image className='user-profile' roundedCircle src="https://cdn.dribbble.com/users/6142/screenshots/5679189/profiledefault_4x.png" alt='' /> */}
                                    <Card.Img className="" variant='top' src="https://cdn.dribbble.com/users/6142/screenshots/5679189/profiledefault_4x.png" />
                                    
                                    <Card.Text className="user-info"> 
                                        <h5>
                                            {auth.prefix == null? (auth.displayname):( auth.prefix + ' ' + auth.displayname)}
                                        </h5>
                                        
                                        <small>                               
                                            <Row > 
                                                <Col xs={3} style={{paddingRight: "4px"}}> CSAM ID </Col>
                                                <Col xs={9} style={{}}>  {auth.userid} </Col>
                                            </Row>
                                        </small>
                                    </Card.Text>
                                </Card.Body>
                                
                            </Card>

                            <ListGroup className='mt-2'>
                                <ListGroup.Item onClick = {e=> setUserView('')} className='li-group-btn' id=''> My Account </ListGroup.Item>
                                <ListGroup.Item onClick = {e=> setUserView('update-profile') } className='li-group-btn' id='update-profile'> Update Profile </ListGroup.Item>
                                { auth.membershipstatus === 'Active' && (<ListGroup.Item onClick = {e=> setUserView('members-view')} className= 'li-group-btn' id ='members-resources'> 
                                    Membership 
                                </ListGroup.Item>)}
                            </ListGroup>

                        </Col>
                        <Col sm={10} md={8} className="mx-auto mb-2" >
                            < UserBoard auth={ auth } currUserView={ currUserView }/>
                        </Col>

                    </Row>
                </Col>
            </Row>
        </Container>
        
    )
}